<template>
<li :class="{
  'disabled' : disabled, 'active' : active,
  '__help-element': isMobile, '__icon-element': icon
}" class="page-item">
  <a class="page-link" :class="className" @click="clickHandler">
    <i v-if="icon" :class="icon" />
    <template v-else>{{text}}</template>
  </a>
</li>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  computed: {
    text() {
      return this.$props.itemType ?? this.$props.number
    }
  },
  props: {
    disabled: Boolean,
    active: Boolean,
    isMobile: Boolean,
    icon: String,
    className: String,
    itemType: String,
    number: Number,
  },
  methods: {
    clickHandler(event) {
      event.preventDefault()
      let number = this.$props.number
      if (this.$props.itemType === 'Previous') number--
      else if (this.$props.itemType === 'Next') number++
      this.$emit('change-page', number)
    }
  }
})
</script>
<style>

</style>